import React, { useState, ReactNode, useEffect } from "react";
import { Icon } from "@iconify/react";
import { useTranslation } from 'react-i18next';

interface HideElementsProps {
    children: ReactNode;
};

const HideElements: React.FC<HideElementsProps> = ({
    children
}) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const savedIsOpen = localStorage.getItem('hideElementsIsOpen');
        if (savedIsOpen !== null) {
            setIsOpen(savedIsOpen === 'true');
        }
    }, []);
    
    useEffect(() => {
        localStorage.setItem('hideElementsIsOpen', String(isOpen));
    }, [isOpen]);

    return (
        <div className="w-full rounded-t-2xl shadow-sm bg-default-50 px-1 py-1">
            <div className="flex items-center w-full">
                <button
                    onClick={() => setIsOpen(!isOpen)}
                    className="flex items-center justify-end w-full gap-1 text-default-500 hover:text-default-900 transition"
                >   
                    {!isOpen && <span className="text-sm font-bold fadeIn">{t('filter_window_table.filter_window_table_26')}</span>}
                    {isOpen && <span className="text-sm font-bold fadeIn">{t('filter_window_table.filter_window_table_27')}</span>}
                    <Icon
                        icon="mdi:chevron-up"
                        className={`text-3xl transform transition duration-300 ${isOpen ? "rotate-0" : "-rotate-180"}`}
                    />
                </button>
            </div>
            <div
                className={`transition-all duration-300 overflow-hidden ${isOpen ? "max-h-[1000px] opacity-100" : "max-h-0 opacity-0"}`}
            >
                {children}
            </div>
        </div>
    );
};

export default HideElements;
